import i18next from 'i18next';

export const generateOpeningHours = (availabilityHours) => {
    let formattedHours = {
        1: [],
        2: [],
        3: [],
        4: [],
        5: [],
        6: [],
        7: []
    };

    availabilityHours.forEach(range => {
        if (range.allDay) {
            formattedHours[range.days.from] = formattedHours[range.days.from].concat(i18next.t('general.open'));
        } else if (range.closed) {
            formattedHours[range.days.from] = formattedHours[range.days.from].concat(i18next.t('general.closed'));
        } else {
            formattedHours[range.days.from] = formattedHours[range.days.from].concat(
                `${range.openTime}-${range.closeTime}`
            );
        }
    });

    return formattedHours;
};